<ng-container *ngIf="isOpen">
  <div class="popover-backdrop" (click)="close()" [@backdropFade]></div>

  <div
    class="popover-panel"
    (click)="$event.stopPropagation()"
    [@panelSlide]="isDesktop ? 'desktop' : 'mobile'"
  >
    <header class="popover-header">
      <!-- <button class="close-btn" (click)="close()" aria-label="Fechar">
        &times; </button> -->
    </header>

    <div class="popover-content">
      <ng-content></ng-content>
    </div>
  </div>
</ng-container>
